import 'bootstrap/dist/css/bootstrap.min.css'
import './stylesheets/cassie.css'
import './stylesheets/App.css'
import Loader from './Components/Loader'
import {
    QueryClient,
    QueryClientProvider,
} from '@tanstack/react-query';
import axios from "axios";
import { GeneralContextProvider } from '../src/utils/generalContext'
import { useState, useEffect } from 'react'
import noimg from './no-img.jpg'
import SwitchingViews from './Views/Layout/switchingViews'
import { useLoading, get, post } from './Generals';

const isJwtExpired = (token) => {
    if (!token) return true;
    try {
        const parts = token.split('.');
        if (parts.length !== 3) return true;
        const base64Url = parts[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
        const payload = JSON.parse(jsonPayload);
        if (!payload.exp) return false;
        const now = Math.floor(Date.now() / 1000);
        return payload.exp < now;
    } catch (e) {
        return true;
    }
};

function App() {
    const [loading, setLoading] = useLoading();
    const [loadingContent, setLoadingContent] = useState(false);
    const [main, setMain] = useState(null);
    const [contract, setContract] = useState(null);
    const [oficina, setOficina] = useState(false);
    const [user, setUser] = useState(JSON.parse(localStorage.getItem('user')));
    const [modalContent, setModalContent] = useState({ title: null, content: null })
    const [modalShow, setModalShow] = useState(false);

    const destroySession = () => {
        setUser(null)
        localStorage.removeItem('user')
        localStorage.removeItem('notified')
        localStorage.removeItem('alert')
        localStorage.removeItem('QuentliToken')

        window.user = {};
    }

    const global = {
        apicode: 'pAiPZ1BNInRc23kq7MtoWsa5FxLXQ9dVzCYSerDfvK6mEwTJgUbG4j0OH8luhy',
        domain: 'https://cursos.birmingham-institute.com/',
        apiDomain: 'https://api.birmingham-institute.com/'
    }

    const toggleModal = () => setModalShow(!modalShow);

    const getMain = async () => {
        try {
            let url = global.domain + "api/v1/getMainData/" + global.apicode
            let res = await axios.get(url);
            setMain(res.data.result)
            setLoading(false);
        } catch (error) {
            console.error("Error loading main data", error);
            setLoading(false);
        }
    }

    useEffect(() => {
        main === null && getMain();
        if (user && user?.user?.no_de_matricula) {
            if (isJwtExpired(user?.authToken)) {
                destroySession();
                return;
            }
            post(
                global.domain + "v3-api/v3/contrato.json",
                { no_de_matricula: user?.user?.no_de_matricula },
                setContract
            );

            !oficina && get(
                global.domain + "v3-api/v3/oficina.json",
                { instituto: user.user.INSTITUTO },
                setOficina
            );
        } else {
            destroySession();
        }
    }, []);

    const queryClient = new QueryClient();
    return (
        <QueryClientProvider client={queryClient}>
            <GeneralContextProvider value={
                {
                    modal: {
                        modalShow,
                        toggleModal,
                        modalContent,
                        setModalContent
                    },
                    loadingContent: {
                        loadingContent,
                        setLoadingContent
                    },
                    main,
                    user: {
                        user,
                        setUser
                    },
                    global,
                    noimg,
                    contract,
                    oficina,
                    destroySession
                }
            }>
                {loading ? <Loader /> : <SwitchingViews />}
            </GeneralContextProvider>
        </QueryClientProvider>
    );
}

export default App;
